import React from 'react';
import { IS_GAME_MODE, ARENA_FOOTER_TEXT, ARENA_AMBER } from '../lib/mode';

// Sticky-bottom disclaimer rendered on every page in Game mode (Agoracle
// Arena, REACT_APP_MODE=game). Returns null in Live mode so the live
// platform is unaffected. Mounted outside <BrowserRouter> so it persists
// across route transitions without re-mount flicker.
//
// z-index is one below the Hazard Stripe (2147483647) so the top stripe
// always wins if both stack. iOS home indicator is cleared via
// env(safe-area-inset-bottom) padding (same pattern as
// SystemBriefingSidebar's mobile DISMISS pill, per CLAUDE.md frontend
// notes on Hazard Stripe).
//
// Pointer events disabled so the footer does not capture taps from
// underlying scrollable content. Visual-only.
export default function ArenaFooter(): React.JSX.Element | null {
  if (!IS_GAME_MODE) return null;
  return (
    <div
      role="contentinfo"
      aria-label="Agoracle Arena disclaimer"
      style={{
        position:       'fixed',
        left:            0,
        right:           0,
        bottom:          0,
        zIndex:          2147483646,
        padding:         `8px 12px calc(env(safe-area-inset-bottom, 0px) + 8px)`,
        background:      'rgba(2, 6, 23, 0.92)',
        borderTop:       `1px solid ${ARENA_AMBER}`,
        color:           ARENA_AMBER,
        fontFamily:      'ui-monospace, SFMono-Regular, Menlo, monospace',
        fontSize:        11,
        fontWeight:      700,
        letterSpacing:   '0.18em',
        textTransform:   'uppercase',
        textAlign:       'center',
        pointerEvents:   'none',
        boxShadow:       '0 -2px 10px rgba(0,0,0,0.55)',
      }}
    >
      ⬡ {ARENA_FOOTER_TEXT}
    </div>
  );
}
